export const RESUME_SCHEDULE_EDIT_MODAL_NAME = 'resumeScheduleEdit';
